/**
 * Sticky Panel Price Fix
 * 
 * This script ensures the sticky add-to-cart panel always shows the lowest available price
 * across all variants, regardless of which variant is currently selected.
 */

(function() {
  // Run immediately after the script loads
  let scriptLoaded = false;
  
  function init() {
    if (scriptLoaded) return;
    scriptLoaded = true;
    
    // Set up a timer to continuously check and update the sticky panel price
    // This ensures our price won't be overridden by other scripts
    setInterval(updateStickyPanelPrice, 500);
    
    // Also run immediately
    updateStickyPanelPrice();
  }
  
  function updateStickyPanelPrice() {
    // Get variants data from the container
    const variantsContainer = document.querySelector('[data-variants-container]');
    if (!variantsContainer) return;
    
    try {
      // Get all variants
      const allVariants = JSON.parse(variantsContainer.getAttribute('data-product-variants'));
      if (!allVariants || !allVariants.length) return;
      
      // Find the lowest price
      let lowestPrice = Number.MAX_SAFE_INTEGER;
      allVariants.forEach(variant => {
        if (variant.available && variant.price < lowestPrice) {
          lowestPrice = variant.price;
        }
      });
      
      if (lowestPrice === Number.MAX_SAFE_INTEGER) return;
      
      // Format the price
      let formattedPrice = formatPrice(lowestPrice);
      
      // Update the sticky panel price element
      const stickyPanel = document.querySelector('.sticky-atc-panel');
      if (!stickyPanel) return;
      
      const stickyPriceElement = stickyPanel.querySelector('[data-product-price]');
      if (!stickyPriceElement) return;
      
      // Make sure the "From" text is present
      const priceParent = stickyPriceElement.parentElement;
      if (priceParent) {
        let fromElement = priceParent.querySelector('.price__from');
        if (!fromElement) {
          fromElement = document.createElement('span');
          fromElement.className = 'price__from';
          fromElement.textContent = Shopify.translations ? 
            Shopify.translations.products_product_from || 'From ' : 
            'From ';
          priceParent.insertBefore(fromElement, stickyPriceElement);
        }
      }
      
      // Update the price
      stickyPriceElement.innerHTML = formattedPrice;
      
      // Remove any compare-at price in the sticky panel
      const compareAtPriceElements = stickyPanel.querySelectorAll('.price__was');
      compareAtPriceElements.forEach(el => el.remove());
    } catch (error) {
      console.error('Error updating sticky panel price:', error);
    }
  }
  
  function formatPrice(cents) {
    // Try to use Shopify's formatMoney if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    
    // Fallback formatting
    return '$' + (cents / 100).toFixed(2);
  }
  
  // Initialize as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
